import React, { useState } from 'react';
import { faqs } from '../mock';
import { Plus, Minus } from 'lucide-react';

const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section className="px-5 md:px-8 py-16 md:py-24">
      <div className="max-w-4xl mx-auto">
        <div className="text-center">
          <div className="text-xs font-bold uppercase tracking-widest text-[#E63946]">Good to know</div>
          <h2 className="font-display text-5xl md:text-7xl uppercase leading-[0.9] mt-2">Questions?</h2>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((f, i) => (
            <div key={i} className="bg-white rounded-2xl crunch-shadow-sm overflow-hidden">
              <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full flex items-center justify-between p-5 md:p-6 text-left">
                <span className="font-display text-xl md:text-2xl uppercase">{f.q}</span>
                <span className="w-9 h-9 rounded-full bg-[#1a1a1a] text-[#FFF4E6] flex items-center justify-center flex-shrink-0">
                  {open === i ? <Minus size={18} /> : <Plus size={18} />}
                </span>
              </button>
              {open === i && (
                <div className="px-5 md:px-6 pb-6 font-brico text-lg leading-relaxed opacity-80">{f.a}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
